import { ThemeColors } from '../theme-colors';

export const Checkbox = {
	// From BaseUI web-page of checkbox
	tickFill: 'var(--epods--checkbox-tickFill)',
	tickFillHover: 'var(--epods--checkbox-tickFillHover)',
	tickFillActive: 'var(--epods--checkbox-tickFillActive)', // TODO: not defined yet
	tickFillSelected: ThemeColors.primary,
	tickFillSelectedHover: 'var(--epods--checkbox-tickFillSelectedHover)', // TODO: not defined yet
	tickFillSelectedHoverActive: 'var(--epods--checkbox-tickFillSelectedHoverActive)', // TODO: not defined yet
	tickFillError: 'var(--epods--checkbox-tickFillError)',
	tickFillErrorHover: 'var(--epods--checkbox-tickFillErrorHover)', // TODO: not defined yet
	tickFillErrorHoverActive: 'var(--epods--checkbox-tickFillErrorHoverActive)', // TODO: not defined yet
	tickFillErrorSelected: 'var(--epods--checkbox-tickFillErrorSelected)', // TODO: not defined yet
	tickFillErrorSelectedHover: 'var(--epods--checkbox-tickFillErrorSelectedHover)', // TODO: not defined yet
	tickFillErrorSelectedHoverActive: 'var(--epods--checkbox-tickFillErrorSelectedHoverActive)', // TODO: not defined yet
	tickFillDisabled: 'var(--epods--checkbox-tickFillDisabled)',
	tickBorder: 'var(--epods--checkbox-tickBorder)',
	tickBorderError: 'var(--epods--checkbox-tickBorderError)', // TODO: not defined yet
	tickMarkFill: 'var(--epods--color-text-inverted)',
	tickMarkFillError: ThemeColors.white,
	tickMarkFillDisabled: ThemeColors.white,
};

export const CustomCheckbox = {
	//TODO: review these variables, here only is needed variables that will change between Themes (tbd)
	tickBorderWidth: '0',
	tickSize: 'var(--epods--checkbox-size-base)',
	tickIconChecked: 'check',
	tickIconIndeterminate: 'remove',
	tickIconFont: 'material-icons',
	labelPadding: 'var(--epods--space-inset-s)',
	labelHPadding: 'var(--epods--checkbox-label-horizontal-padding)',
	labelColor: 'var(--epods--checkbox-label-color)',
	descriptionSize: 'var(--epods--checkbox-caption-size)',
	descriptionHeight: 'var(--epods--checkbox-caption-height)',
	descriptionMargin: 'var(--epods--checkbox-caption-margin)',
	descriptionColor: 'var(--epods--checkbox-caption-color)',

	tickFillDisabledSelected: 'var(--epods--color-blue-50)', // TODO: unknown yet
	tickFillPositive: 'var(--epods--color-bluegrey-100)',
	tickFillPositiveHover: 'var(--epods--color-bluegrey-50)', // TODO: not defined yet
	tickFillPositiveHoverActive: 'var(--epods--color-bluegrey-200)', // TODO: not defined yet
	tickFillPositiveActive: 'var(--epods--color-bluegrey-200)',
	tickFillPositiveSelected: 'var(--epods--color-lightgreen-700)', // TODO: not defined yet
	tickFillPositiveSelectedHover: 'var(--epods--color-lightgreen-600)', // TODO: not defined yet
	tickFillPositiveSelectedHoverActive: 'var(--epods--color-lightgreen-900)', // TODO: not defined yet
	tickBorderPositive: 'var(--epods--color-bluegrey-100)', // TODO: not defined yet
	labelColorDisabled: 'var(--epods--color-text-disabled)',
	tickFillCustomIcon: 'grey', // TODO: tbd #
	tickFillCustomIconChecked: 'black', // TODO: tbd #
};
